import Funnel from "../../services/funnel-service.js";

const template = `
    <div  v-show="fs.display(input)">
        <p :id="input.uid" :class="input.class" v-html="input.value"></p>
    </div>
`;

export default {
    name: 'qt-text-block',
    template,
    props: ['iuid'],
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
    },
    methods: {
    }
};
